module.exports = __webpack_public_path__ + "static/media/chevron-down.3e445e9d.svg";